<template>
  <div id="contacts">
    <v-row no-gutters>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            <v-spacer/>
            <v-text-field
              style="max-width: 250px"
              dense
              outlined
              hide-details
              clearable
              :placeholder="$t('general.search')"
              v-model="search"
              append-icon="search"
              class="mr-2"
              @keyup.enter="searching"
              @click:append="searching"
            />
          </v-card-title>
          <v-card-text>
            <v-data-table
              :search="search"
              :headers="headers"
              :items="contacts"
              :footer-props="{ 'items-per-page-options': [15, 25, 50] }"
              :options.sync="options"
              :server-items-length="options.total"
              :loading="loadTable"
              @update:page="get"
              @update:items-per-page="get"
              @update:sort-by="get"
              @update:sort-desc="get"
            >
              <template v-slot:item="props" >
                <tr>
                  <td style="border-bottom: none;">{{props.item.name}}</td>
                  <td style="border-bottom: none;">{{props.item.email}}</td>
                  <td style="border-bottom: none;">{{props.item.subject}}</td>
                  <td style="border-bottom: none;">{{props.item.phone}}</td>
                  <td style="border-bottom: none;">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon small @click="remove(props.item)" v-on="on">far fa-trash-alt</v-icon>
                      </template>
                      <span>{{$t('general.remove')}}</span>
                    </v-tooltip>
                  </td>
                </tr>
                <tr>
                  <td colspan="5"><span class="font-weight-black primary--text">{{$t('notification.message')}}: </span><span v-html="props.item.message"></span></td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" width="500px">
      <v-card>
        <v-toolbar color="grey lighten-5" flat class="mb-5">
          <h3 class="error--text">{{$t('general.confirm')}}</h3>
        </v-toolbar>
        <v-card-text>
          <p>{{$t('units.delMessage')}}?</p>
          <p><span class="error--text font-weight-black">{{$t('general.name')}}:</span> {{removedItem.name}}</p>
          <p><span class="error--text font-weight-black">{{$t('general.email')}}:</span> {{removedItem.email}}</p>
          <p><span class="error--text font-weight-black">{{$t('general.subject')}}:</span> {{removedItem.subject}}</p>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="error" text @click="close">{{$t('general.cancel')}}</v-btn>
          <v-btn
            color="error"
            depressed
            @click="confirmRemove"
            :loading="loading"
            :disabled="loading"
          >{{$t('general.accept')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: 'contacts',
  data () {
    return {
      loading: false,
      loadTable: false,
      dialog: false,
      search: '',
      defaultItem: {
        name: '',
        email: '',
        subject: ''
      },
      removedItem: {
        name: '',
        email: '',
        subject: ''
      },
      contacts: [
        {
          id: 1,
          name: 'John Smith',
          email: 'JohnSmith@email.com',
          subject: 'Solicitud de informacion',
          message: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nesciunt repudiandae eveniet saepe provident asperiores animi officiis temporibus est quas deserunt.',
          phone: '1234567890'
        }
      ],
      options: {
        page: 1,
        itemsPerPage: 15,
        total: 0
      },
    }
  },
  created () {
    this.initialize()
  },
  watch: {
    search (val) {
      if (val === '' || val === null) this.searching()
    }
  },
  computed: {
    headers () {
      return [
        {
          text: this.$t('general.name'),
          value: 'name',
          sortable: true
        },
        {
          text: this.$t('general.email'),
          value: 'email',
          sortable: true
        },
        {
          text: this.$t('general.subject'),
          value: 'subject',
          sortable: true
        },
        {
          text: this.$t('general.phone'),
          value: 'phone',
          sortable: true
        },
        {
          text: this.$t('general.actions'),
          sortable: false
        }
      ]
    },
  },
  methods: {
    get () {
      this.loadTable = true
      this.$store.dispatch('getContacts', {
        event: {
          item: {
            perPage: this.options.itemsPerPage,
            page: this.options.page,
            sortKey: this.options.sortBy ? this.options.sortBy[0] : undefined,
            ord: this.options.sortDesc && this.options.sortDesc[0] ? 'desc' : 'asc',
            find: this.search
          },
          context: this
        }
      })
    },
    searching () {
      this.options.page = 1
      this.options.perPage = 5
      this.get()
    },
    initialize () {
      this.loadTable = true
      this.get()
    },
    remove (item) {
      this.removedItem = item
      this.dialog = true
    },
    close () {
      this.dialog = false
      this.loading = false
      this.removedItem = Object.assign({}, this.defaultItem)
    },
    confirmRemove () {
      this.loading = true
      this.$store.dispatch('deleteContact', {event: {item: this.removedItem, context: this}})
    }
  }
}
</script>